import Gallery from "./index.vue"

export default Gallery